import Chart from "../../styles/Chart.module.css";
import {
  ResponsiveContainer,
  AreaChart,
  XAxis,
  YAxis,
  Area,
  Tooltip,
  CartesianGrid,
} from "recharts";

export default function DataChart({ history }) {
  const data = history;
  return (
    <ResponsiveContainer width="100%" height={230}>
      <AreaChart
        data={data}
        margin={{ top: 20, right: 30, left: 0, bottom: 0 }}
      >
        <XAxis dataKey="year" tickCount={5} fontSize="13px" />
        <defs>
          <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#8884d8" stopOpacity={0.8} />
            <stop offset="95%" stopColor="#8884d8" stopOpacity={0} />
          </linearGradient>
        </defs>
        <YAxis
          tickCount={5}
          fontSize="13px"
          axisLine={false}
          tickLine={0}
          tickFormatter={(number) => `$ ${abbreviateNumber(number)}`}
        />
        <CartesianGrid strokeDasharray="5 5" y={3000} />
        <Tooltip content={<CustomTooltip />} />
        <Area
          type="monotone"
          dataKey="median_sold_price"
          activeDot={{ stroke: "#fff", strokeWidth: 2, r: 6 }}
          stroke="var(--dark-color)"
          fill="#054ef956"
          fillOpacity={1}
          strokeWidth={3.5}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}

function CustomTooltip({ active, payload, label }) {
  if (active && payload && payload.length) {
    return (
      <div className={Chart.tooltip}>
        <p className={Chart.label}>{`${label}`}</p>
        <p className={Chart.price}> $ {payload[0].value.toLocaleString()}</p>
        <p className={Chart.textBox}>median sold price</p>
      </div>
    );
  }

  return null;
}

function abbreviateNumber(value) {
  var newValue = value;
  if (value >= 1000) {
    var suffixes = ["", " k", " m", " b", " t"];
    var suffixNum = Math.floor(("" + value).length / 3);
    var shortValue = "";
    for (var precision = 2; precision >= 1; precision--) {
      shortValue = parseFloat(
        (suffixNum != 0
          ? value / Math.pow(1000, suffixNum)
          : value
        ).toPrecision(precision)
      );
      var dotLessShortValue = (shortValue + "").replace(/[^a-zA-Z 0-9]+/g, "");
      if (dotLessShortValue.length <= 2) {
        break;
      }
    }
    if (shortValue % 1 != 0) shortValue = shortValue.toFixed(1);
    newValue = shortValue + suffixes[suffixNum];
  }
  return newValue;
}
